import api from './api';

// Settings > AI Configuration. Admin only on every call, enforced server-side.
//
// THE API KEY ONLY EVER TRAVELS ONE WAY. `get` returns `key_set` and
// `api_key_hint` (last four characters) and never the key itself, so this screen
// cannot display one and does not try. `saveProvider` sends `api_key` ONLY when
// an administrator is deliberately replacing it — omitting the field means "keep
// the stored key", never "clear it", because a screen that cannot read a key
// would otherwise wipe it every time someone saved a checkbox. Clearing is
// deliberate: remove the provider.
//
// send_results_to_model is the other field worth understanding here: it decides
// whether query RESULTS (real budget figures) may be sent to the provider so it
// can write a prose answer. Off means the model only picks the query and Mantle
// renders the table locally.
export const aiConfigService = {
  get: async () => {
    const res = await api.get('/ai-config');
    return res.data;
  },

  // provider: { provider_code, display_name, api_style, base_url, is_active,
  //             timeout_seconds, max_output_tokens, notes, api_key? }
  saveProvider: async (provider) => {
    const res = await api.put('/ai-config/provider', { provider });
    return res.data;
  },

  // The smallest real call to the provider, to prove the endpoint, key and model
  // code are valid. Carries no tenant data. A FAILED test comes back as HTTP 200
  // with success:false — the failure is the useful result, not an exception.
  testProvider: async (providerCode, modelCode) => {
    const res = await api.post('/ai-config/test', {
      provider_code: providerCode,
      model_code: modelCode || undefined,
    });
    return res.data;
  },

  deleteProvider: async (code) => {
    const res = await api.delete(`/ai-config/provider/${encodeURIComponent(code)}`);
    return res.data;
  },

  // model: { provider_code, model_code, display_name, context_tokens,
  //          is_default, is_active, sort_order, notes }
  saveModel: async (model) => {
    const res = await api.put('/ai-config/model', { model });
    return res.data;
  },

  deleteModel: async (providerCode, modelCode) => {
    const res = await api.delete(
      `/ai-config/model/${encodeURIComponent(providerCode)}/${encodeURIComponent(modelCode)}`
    );
    return res.data;
  },
};

export default aiConfigService;
